export type FeaturedProject = {
  id: string
  name: string
  tagline: string
  href: string
  image: string
  destinationId: "earth" | "mars" | "moon" | "frontier-world"
}

/** In-scene cards. Music stack only. */
export const FEATURED_PROJECTS: FeaturedProject[] = [
  {
    id: "black-velvet",
    name: "BLACK VELVET RECORDS",
    tagline: "The music platform. Artists, wars, live hubs.",
    href: "#black-velvet-records",
    image: "/images/portfolio/black-velvet-records/bvr-home.webp",
    destinationId: "earth",
  },
  {
    id: "bvr-flow",
    name: "BVR FLOW",
    tagline: "Arranges your samples into Ableton songs.",
    href: "#bvr-flow",
    image: "/images/portfolio/bvr/bvr-flow-song-maker.webp",
    destinationId: "mars",
  },
  {
    id: "bvr-volt",
    name: "BVR VOLT",
    tagline: "Subtractive synth, AI patches, sequencer.",
    href: "#bvr-volt",
    image: "/images/portfolio/bvr/bvr-volt.webp",
    destinationId: "moon",
  },
  {
    id: "ai-mastering",
    name: "AI MASTERING",
    tagline: "Own DSP. Analyze, plan, master locally.",
    href: "#ai-mastering",
    image: "/images/portfolio/ai-mastering/dashboard.webp",
    destinationId: "frontier-world",
  },
]

export function projectForDestination(
  destinationId: string | undefined,
): FeaturedProject | null {
  if (!destinationId) return null
  return FEATURED_PROJECTS.find((p) => p.destinationId === destinationId) ?? null
}
